import React from 'react';
import '../css/ScrollBarH.css';

const ScrollingBar = () => {
  return (
    <div className="scrolling-bar">
      <div className="scrolling-content">
      🏆 Last month winner 🏆 <strong>1st</strong> Rank <strong>Hfdji</strong>  
  🏆 Last month winner 🏆 <strong>2nd</strong> Rank <strong>Rjbet</strong>  
  🏆 Last month winner 🏆 <strong>3rd</strong> Rank <strong>jai shree om banna</strong>  
  🏆 Last month winner 🏆 <strong>4th</strong> Rank <strong>TatRl</strong>  
  🏆 Last month winner 🏆 <strong>5th</strong> Rank <strong>000000</strong>  
  🏆 Last month winner 🏆 <strong>6th</strong> Rank <strong>Devils</strong>  
  🏆 Last month winner 🏆 <strong>7th</strong> Rank <strong>kNpmK</strong>  
  🏆 Last month winner 🏆 <strong>8th</strong> Rank <strong>Nittu</strong>  
  🏆 Last month winner 🏆 <strong>9th</strong> Rank <strong>Fgxkdb</strong>  
  🏆 Last month winner 🏆 <strong>10th</strong> Rank <strong>atovV</strong>  
  🏆 Last month winner 🏆 <strong>11th</strong> Rank <strong>vfcjP</strong>  
  🏆 Last month winner 🏆 <strong>12th</strong> Rank <strong>SUNIL</strong>  
  🏆 Last month winner 🏆 <strong>13th</strong> Rank <strong>KRhtq</strong>  
  🏆 Last month winner 🏆 <strong>14th</strong> Rank <strong>Shanichar</strong>  
  🏆 Last month winner 🏆 <strong>15th</strong> Rank <strong>hSmsH</strong>  
  🏆 Last month winner 🏆 <strong>16th</strong> Rank <strong>jxTac</strong>  
  🏆 Last month winner 🏆 <strong>17th</strong> Rank <strong>Sonuu</strong>  
  🏆 Last month winner 🏆 <strong>18th</strong> Rank <strong>Aamit</strong>  
  🏆 Last month winner 🏆 <strong>19th</strong> Rank <strong>qLLje</strong>  
  🏆 Last month winner 🏆 <strong>20th</strong> Rank <strong>Civil</strong>  
  🏆 Last month winner 🏆 <strong>21st</strong> Rank <strong>KPHXQ</strong> 
      </div>
    </div>
  );
};

export default ScrollingBar;
